import { CARGAR_MOVIMIENTOSCAJA } from '../actions/caja/actionTypes';

const cajaReducer = (state={ mvtosCaja:[]}, action) => {
    switch(action.type){
        case CARGAR_MOVIMIENTOSCAJA:
            return {...state, mvtosCaja: action.data };
        default:
            return state;
    }
};

export default cajaReducer;